document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.social-media-module-container');
    if (!container) return;

    const viewMoreButton = container.querySelector('.view-more--button');
    if (!viewMoreButton) return;

    viewMoreButton.addEventListener('click', () => {
        container.classList.toggle('show-more');

        if (!container.classList.contains('show-more'))
            container.scrollIntoView({behavior: 'smooth', block: 'center'});
    });
});
